import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container } from "@material-ui/core";
import CompanyHeader from "./CompanyHeader.jsx";
import CompanyFooter from "./CompanyFooter.jsx";

const useStyles = makeStyles(() => ({
  mainContainer: {
    minHeight: "100vh",
  },
}));

/** @returns {*}
 * @constructor
 */
const CompanyLayout = ({ children }) => {
  const classes = useStyles();
  return (
    <Container maxWidth="lg" className={classes.mainContainer}>
      <CompanyHeader />
      {children}
      <CompanyFooter />
    </Container>
  );
};

export default CompanyLayout;
